const NOOM_SESSION_STORAGE_PREFIX = "noom_";

export function getNoomSessionStorage<T extends AnyJson>(key: string): T {
  try {
    return JSON.parse(
      sessionStorage.getItem(NOOM_SESSION_STORAGE_PREFIX + key)
    );
  } catch (e) {
    return undefined;
  }
}

export function setNoomSessionStorage(key: string, value: AnyJson) {
  sessionStorage.setItem(
    NOOM_SESSION_STORAGE_PREFIX + key,
    JSON.stringify(value)
  );
}
